import { cn } from '@core-utils/cn';
import { forwardRef } from 'react';

import styles from './Form.module.scss';

type FormFieldsetProps = React.FieldsetHTMLAttributes<HTMLFieldSetElement>;

const FormFieldset = forwardRef<HTMLFieldSetElement, FormFieldsetProps>(
    function FormFieldset({ className, ...props }, ref) {
        return (
            <fieldset
                ref={ref}
                className={cn(styles.FormFieldset, className)}
                {...props}
            />
        );
    },
);

type FormLegendProps = React.HTMLAttributes<HTMLLegendElement>;

const FormLegend = forwardRef<HTMLLegendElement, FormLegendProps>(
    function FormLegend({ className, ...props }, ref) {
        return (
            <legend
                ref={ref}
                className={cn(styles.FormLegend, className)}
                {...props}
            />
        );
    },
);

export { FormFieldset };
export { FormLegend }
